import classNames from "classnames";
import { Actor } from "@zapier/canvas-state";
import { ActorLabel } from "../ActorLabel";
import styles from "./ActorLabelPositioner.module.css";

type Props = {
  actor: Actor;
  shouldOverlap: boolean;
};

export function ActorLabelPositioner({ actor, shouldOverlap = true }: Props) {
  return (
    <div
      className={classNames({
        [styles.overlapping]: shouldOverlap,
        [styles.notOverlapping]: !shouldOverlap,
      })}
    >
      <ActorLabel actor={actor} />
    </div>
  );
}
